/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from 'react'
import Helmet from 'react-helmet'

const GoogleAnalytics = () => {
  const trackingId = process.env.GOOGLE_ANALYTICS_TRACKING_ID
  const isQA = process.env.GATSBY_ENVIRONMENT === 'staging'

  return (
    <Helmet>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}&l=gtagDataLayer`}></script>
      <script>
        {`
            window.gtagDataLayer = window.gtagDataLayer || [];
            window.gtag2 = window.gtag2 || function gtag(){gtagDataLayer.push(arguments);}
            gtag2('consent', 'default', {
              'ad_storage': 'denied',
              'analytics_storage': 'denied',
              'functionality_storage': 'denied',
              'personalization_storage': 'denied',
              'security_storage': 'denied'
            });
            gtag2('js', new Date());
            gtag2('set', 'linker', {'domains': ['mealpal.co.uk', 'mealpal.co.nz', 'mealpal.com.au', 'mealpal.com', 'secure.mealpal.com']});
            gtag2('config', '${trackingId}');
          `}
      </script>

      <script>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-MRSXQD');

        `}
      </script>
      <meta name="facebook-domain-verification" content="x2ldjrbeb8c99o30dnt83qn5ndbq7i" />
      {isQA && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  )
}

export default GoogleAnalytics
